module.exports = __webpack_public_path__ + "static/media/vegitables_44.066b4eb5.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_44.csv
// module id = 629
// module chunks = 0